import { render, staticRenderFns } from "./TextSetting.vue?vue&type=template&id=641f3434&"
import script from "./TextSetting.vue?vue&type=script&lang=js&"
export * from "./TextSetting.vue?vue&type=script&lang=js&"
import style0 from "./TextSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('641f3434')) {
      api.createRecord('641f3434', component.options)
    } else {
      api.reload('641f3434', component.options)
    }
    module.hot.accept("./TextSetting.vue?vue&type=template&id=641f3434&", function () {
      api.rerender('641f3434', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Settings/TextSetting.vue"
export default component.exports